import request from '@/utils/request'

export function ExamUselistScorePage(data) {
	return request({
		url: '/exam-user/list-score-page',
		method: 'post',
		headers: { 'oper': '用户成绩列表获取', 'oper-type': 1006 },
		data
	})
}
export function EnrollInfoListRecertPage(data) {
	return request({
		url: '/enroll-info/list-recert-page',
		method: 'post',
		headers: { 'oper': '我的再认证列表获取', 'oper-type': 1007 },
		data
	})
}
export function enrollCertListPage(data) {
	return request({
		url: '/cert/list',
		method: 'post',
		headers: { 'oper': '我的电子证书获取', 'oper-type': 1008 },
		data
	})
}

export function enrollInfoRecertEnroll(data) {
	return request({
		url: '/enroll-info/recert-enroll',
		method: 'post',
		headers: { 'oper': '用户再认证', 'oper-type': 1009 },
		data
	})
}
export function enrollInfoDetailAll(data) {
	return request({
		url: '/enroll-info/detail-all',
		method: 'post',
		headers: { 'oper': '再认证所有信息获取', 'oper-type': 1010 },
		data
	})
}
export function certDetail(data) {
	return request({
		url: '/cert/detail',
		method: 'post',
		headers: { 'oper': '证书查看', 'oper-type': 1011 },
		data
	})
}
export function userGetUserInfo(data) {
	return request({
		url: '/user/getUserInfo',
		method: 'post',
	headers: { 'oper': '用户信息获取', 'oper-type': 1012 },
		data
	})
}
export function userUpdate(data) {
	return request({
		url: '/user/update',
		method: 'post',
		headers: { 'oper': '用户信息更改', 'oper-type': 1013 },
		data
	})
}
export function noticeMyList(data) {
	return request({
		url: '/notice/my-list',
		method: 'post',
		headers: { 'oper': '我的消息获取', 'oper-type': 1014 },
		data
	})
}
export function noticeDetail(data) {
	return request({
		url: '/notice/detail',
		method: 'post',
	headers: { 'oper': '我的消息详情查看', 'oper-type': 1015 },
		data
	})
}
export function enrollThesisList(data) {
	return request({
		url: '/enroll-thesis/list-page',
		method: 'post',
		headers: { 'oper': '我的论文列表', 'oper-type': 1016 },
		data
	})
}
export function questionListPage(data) {
	return request({
		url: '/question/list-page',
		method: 'post',
		headers: { 'oper': '我的问答', 'oper-type': 1017 },
		data
	})
}
export function questionAdd(data) {
	return request({
		url: '/question/add',
		method: 'post',
		headers: { 'oper': '问题添加', 'oper-type': 1018 },
		data
	})
}
export function questionTypeList(data) {
	return request({
		url: '/question-type/list',
		method: 'post',
		headers: { 'oper': '问题类型获取', 'oper-type': 1019 },
		data
	})
}
export function questionDetail(data) {
	return request({
		url: '/question/detail',
		method: 'post',
		headers: { 'oper': '问题查看详情', 'oper-type': 1020 },
		data
	})
}
export function rankMessageList(data) {
	return request({
		url: '/rank-message/list',
		method: 'post',
		headers: { 'oper': '问题查看列表', 'oper-type': 1021 },
		data
	})
}
export function orderAuditList(data) {
	return request({
		url: '/order/audit-list',
		method: 'post',
		headers: { 'oper': '订单列表查询', 'oper-type': 1022 },
		data
	})
}
export function orderAdd(data) {
	return request({
		url: '/order/add',
		method: 'post',
		headers: { 'oper': '再认证订单添加', 'oper-type': 1023 },
		data
	})
}

export function examUserDetail(data) {
	return request({
		url: '/exam-user/detail',
		method: 'post',
		headers: { 'oper': '报名信息查看详情', 'oper-type': 1024 },
		data
	})
}

export function enrollReceiverDetail(data) {
	return request({
		url: '/enroll-receiver/last-enroll-receiver-detail',
		method: 'post',
		headers: { 'oper': '收货地址查看', 'oper-type': 1025 },
		data
	})
}

export function enrollReceiverUpdate(data) {
	return request({
		url: '/enroll-receiver/update',
		method: 'post',
		headers: { 'oper': '收货地址修改', 'oper-type': 1026 },
		data
	})
}
export function thesisAdd(data) {
	return request({
		url: '/enroll-thesis/add',
		method: 'post',
		headers: { 'oper': '论文上传', 'oper-type': 1027 },
		data
	})
}
export function rankMessageAdd(data) {
	return request({
		url: '/rank-message/add',
		method: 'post',
		headers: { 'oper': '再次提问', 'oper-type': 1028 },
		data
	})
}
 export function questionUdate(data) {
 	return request({
 		url: '/question/update',
 		method: 'post',
 		headers: { 'oper': '再次提问', 'oper-type': 1029 },
 		data
 	})
 }